import { UnitStateData } from '@mark43/cad-api';

export function formatUnitStateData(unitStateData: UnitStateData): string {
    return `${unitStateData.abbreviation} - ${unitStateData.value}`;
}
